import {EntityApiService, ApiClientService} from '@dofleini/security';

class TemplatesApiService extends EntityApiService {
  duplicate = (params) => {
    return ApiClientService.post(this.getPath(`/${params._id}/duplicate`), params);
  };

  getOneTemplate = ({templateId}, params) => {
    const config = {params};
    if (params?.projections && Array.isArray(params.projections)) {
      config.params = {
        ...params,
        projections: params.projections.join(',')
      };
    }
    return ApiClientService.get(this.getPath(`/${templateId}`), config);
  }

  clientsSearch = (params) => ApiClientService.post(this.getPath('/clients/search'), params);

}

export default new TemplatesApiService('/ms-core/api/audit-templates');
